<template>
  <div
      :class="{'topic-collapsed': topicBoardCollapsed}"
      class="right-user-wrap">
    <el-popover
        placement="bottom"
        :width="200"
        trigger="hover"
        popper-class="right-user-content-box-7719"
    >
      <template #reference>
        <div
            class="right-icon"
        >
          <el-icon color="#FFFFFF" size="30">
            <User/>
          </el-icon>
        </div>
      </template>
      <div class="content-box">
        <div class="info">
          欢迎您, {{ showUsername }}
        </div>
        <div class="info">
          纳税人名称: 北京仁和科技有限公司
        </div>
        <div class="info">
          统一社会信用代码/纳税人识别号: 91110104533585261H
        </div>

        <div class="btns">
          <el-button text icon="User" @click="goAccCenter">账户中心</el-button>
          <el-button text icon="Refresh" style="margin-left: 60px;">身份切换</el-button>
          <br/>
          <el-button text icon="Wallet"
                     style="margin-left: 0;"
                     @click="quitLogin"
          >退出登录
          </el-button>
        </div>

      </div>
    </el-popover>

    <div v-if="showBack" class="back-bt" @click="emits('changePage', 'package')">
      返回
    </div>
  </div>
</template>

<script setup>
import {ElMessage} from "element-plus";
import {removeLogin} from "@/views/digitalInvoice/digitalLoginHandler.js";

const topicBoardCollapsed = inject('topicBoardCollapsed');
const emits = defineEmits(['changePage']);

const props = defineProps({
  showBack: {
    type: Boolean,
    default: false
  }
})

onMounted(() => {
})

const currentQa = inject('provideCurrentQa');

const showUsername = computed(() => {
  const loginType = sessionStorage.getItem('digTaxLoginType_' + currentQa.value.queId)
  if (loginType == 2) { // 自然人登录
    return '王*霞'
  }
  return 'admin'
})

function quitLogin() {
  sessionStorage.removeItem('digTaxLoginType_' + currentQa.value.queId)
  removeLogin()
  emits('changePage', 'stateTaxHome');
}

function goAccCenter() {
  if (currentQa.value.sonQueType == '38') {
    emits('changePage', 'accountCenter');
  } else {
    ElMessage({
      message: '当前题目业务模块非[新增开票人]',
      type: 'warning',
      duration: 3500
    })
  }
}
</script>


<style scoped lang="scss">
.right-user-wrap {
  display: flex;
  margin-right: 60px;
  align-items: center;

  .right-icon {
    width: 40px;
    height: 40px;
    background: #b4d4fa;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .back-bt {
    margin-left: 15px;
    color: #FFFFFF;
    cursor: pointer;
  }

  &.topic-collapsed {
    margin-right: 245px;
  }
}
</style>

<style lang="scss">
.right-user-content-box-7719 {
  width: 350px !important;
  box-sizing: border-box;
  padding: 15px 15px 5px 15px !important;

  .content-box {
    .info {
      font-size: 12px;
      line-height: 30px;
      color: #666666;
    }

    .btns {
      margin-left: -15px;
    }
  }
}
</style>
